document.addEventListener('DOMContentLoaded', function () {

    function updateVendorSKU(form) {

        if (!form) return;

        const skuInput = form.querySelector('.google-vendor-sku-property');
        const variantInput = form.querySelector('.product-variant-id');

        if (!skuInput || !variantInput) return;

        const productId = skuInput.dataset.productId;
        const variantId = variantInput.value;

        if (
            window.variantVendorSKUs &&
            window.variantVendorSKUs[productId] &&
            window.variantVendorSKUs[productId][variantId]
        ) {

            skuInput.value = window.variantVendorSKUs[productId][variantId];

        } else {

            skuInput.value = '';

        }

        // Optional: Update displayed SKU if present
        const skuLabel = document.getElementById('vendor-sku-' + productId);

        if (skuLabel) {
            skuLabel.textContent = skuInput.value
                ? 'SKU = ' + skuInput.value
                : '';
        }
    }


    // Update when variant changes
    document.addEventListener('change', function () {

        document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){

            updateVendorSKU(form);

        });

    });


    // Ensure correct SKU just before Add to Cart
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){

        updateVendorSKU(form);

        form.addEventListener('submit', function (e) {
            updateVendorSKU(form);
            const skuInput = form.querySelector('.google-vendor-sku-property');
            console.log("Submitting Vendor SKU:", skuInput.value);
        }, true);

    });

});
